import fileDetail from './file-detail'

export default [
  ...fileDetail
]
